<div class="d-flex min-vh-100">
  @if (!profileService.isSuperAdmin()) {
  <c-sidebar
    #sidebar1="cSidebar"
    class="d-print-none sidebar sidebar-fixed border-end"
    id="sidebar1"
    [narrow]="sidebarMinimized && !isMobile"
    [visible]="!isMobile"
  >
    <c-sidebar-header>
      <c-sidebar-brand [routerLink]="['/dashboard']">
        @if (logoFailed) {
          <span
            class="company-avatar"
            [style.backgroundColor]="sidebarAccentColor"
            [title]="companyName"
            [attr.aria-label]="companyName"
          >{{ companyInitials }}</span>
        } @else {
          <img
            [src]="logo"
            width="90"
            height="75"
            alt="Company Logo"
            (error)="onLogoError()"
          />
        }
          <!-- <img [src]="logo" width="90" height="75" alt="Company Logo" /> -->
      </c-sidebar-brand>
    </c-sidebar-header>

    <ng-scrollbar pointerEventMethod="scrollbar" visibility="hover">
      <c-sidebar-nav [navItems]="navItems" dropdownMode="close" compact />
    </ng-scrollbar>

    <c-sidebar-footer
      class="border-top d-none d-lg-flex justify-content-center p-2"
      style="cursor: pointer"
      (click)="toggleSidebar()"
      [title]="sidebarMinimized ? 'Expand menu' : 'Minimize menu'"
    >
      <div class="d-flex align-items-center justify-content-center gap-2" style="color: var(--cui-sidebar-color); opacity: 0.6;">
        @if (sidebarMinimized) {
          <svg cIcon name="cilChevronRight" size="lg"></svg>
        } @else {
          <svg cIcon name="cilChevronLeft" size="lg"></svg>
        }
      </div>
    </c-sidebar-footer>
  </c-sidebar>
  }

  <div class="wrapper d-flex flex-column flex-grow-1" [class.wrapper--no-sidebar]="profileService.isSuperAdmin()">
  <app-default-header 
    [notifications]="notifications" 
    [notCount]="notCount" 
    [profile]="profile"
    class="d-print-none"
    (asideToggle)="toggleAside()"
  >
  </app-default-header>

  @if (planFree) {
  <div class="free-plan-alert">
    <div class="container-fluid">
      <c-alert color="warning" class="text-center">
        <p>
          <i class="fa-solid fa-triangle-exclamation"></i>
          You're using the Free Version of Field Tech. Functionality is limited
          to one user, basic work order creation, and scheduling only.
        </p>
        <p>
          <i class="fa-solid fa-hand-point-right"></i>
          <a href="https://fieldtechfitness.com/app-features/" target="_blank">
            Click here to see everything you're missing
          </a>
          — and discover how Field Tech can
          <b> increase your efficiency and profitability. </b>
        </p>
      </c-alert>
    </div>
  </div>
  }

  @if (superAdminService.isImpersonating) {
  <div class="impersonation-bar d-print-none">
    <span>
      <i class="fa-solid fa-user-secret"></i>
      You are signed in as
      <b>{{ superAdminService.impersonatedName }}</b>. Every request you make is recorded in the
      impersonation audit log.
    </span>
    <span class="impersonation-bar__timer" *ngIf="impersonationCountdown">
      <i class="fa-solid fa-clock"></i>
      Session ends in {{ impersonationCountdown }}
    </span>
    <button type="button" class="btn btn-sm btn-light" (click)="stopImpersonation()">
      Back to my account
    </button>
  </div>
  }

  <div class="body flex-grow-1 container-fluid">
    <router-outlet />
  </div>
  </div>
</div>

<!-- Aside Panel (Settings) using CoreUI Offcanvas -->
<c-offcanvas
  placement="end"
  [visible]="asideVisible"
  (visibleChange)="asideVisible = $event"
  id="offcanvasAside"
>
  <c-offcanvas-header>
    <h5>Settings</h5>
    <button type="button" class="btn-close" (click)="toggleAside()" aria-label="Close"></button>
  </c-offcanvas-header>
  
  <c-offcanvas-body>
    <div class="p-3">
      <h6>Theme Colors</h6>
      <div class="theme-color-selector">
        <div class="row">
          @for (color of availableColors; track color.value) {
            <div class="col-6 mb-2">
              <button
                type="button"
                class="btn btn-sm w-100"
                [style.backgroundColor]="color.color"
                [style.color]="'white'"
                (click)="setColor(color.value)"
                [class.active]="profileService.profileInfo?.components_color === color.value"
              >
                {{color.name}}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </c-offcanvas-body>
</c-offcanvas>
